// src/pages/admin/Page_REVI/Page_REVI_Formacion.js
//
// Tab "Formación" del panel REVI admin. Gestiona los recursos que ven los
// terapeutas en /portal/therapist/documentacion y las instituciones REVI en
// /portal/inst/documentacion:
//   - Vídeos (carrusel en portal -> grid en admin)
//   - Guías PDF (idem)
//   - Información de REVI: un bloque por audiencia (terapeuta e institución)
//
// 2026-08-04: la pagina pasa a apoyarse en FormacionManager, el gestor comun
// de las dos verticales. Aqui solo queda la configuracion propia de REVI.

import React from "react";
import { ReviResourceAPI } from "../../../api";
import { useAuth } from "../../../hooks";
import { FormacionManager } from "../../../components/Admin/FormacionCmp";

const api = new ReviResourceAPI();

// Constantes a nivel de modulo: si se declararan dentro del componente,
// cambiarian de referencia en cada render y dispararian recargas en bucle.
const AUDIENCE_OPTIONS = [
  { value: "therapist", label: "Terapeutas" },
  { value: "institution", label: "Instituciones" },
];

const INFO_BLOCKS = [
  {
    audience: "therapist",
    title: "Información de REVI (terapeutas)",
    titlePlaceholder: "Ej. Bienvenido a REVI",
    descriptionPlaceholder:
      "Texto sobre la plataforma REVI que se mostrará al terapeuta.",
    emptyText: "Aún no hay información para terapeutas",
  },
  {
    audience: "institution",
    title: "Información de REVI (instituciones)",
    titlePlaceholder: "Ej. REVI para tu centro",
    descriptionPlaceholder:
      "Texto sobre la plataforma REVI que se mostrará a la institución.",
    emptyText: "Aún no hay información para instituciones",
  },
];

export function Page_REVI_Formacion() {
  const { accessToken } = useAuth();

  return (
    <FormacionManager
      api={api}
      accessToken={accessToken}
      audienceOptions={AUDIENCE_OPTIONS}
      infoBlocks={INFO_BLOCKS}
    />
  );
}
